{
    "version": "0.1.0",
    "name": "bpl_token_metadata",
    "instructions": [
        {
            "name": "createAdminSettings",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "adminSettings",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "admin"
                            }
                        ]
                    }
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "data",
                    "type": {
                        "defined": "AdminSettings"
                    }
                }
            ]
        },
        {
            "name": "createPromo",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "mint",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "metadata",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "authority"
                            }
                        ]
                    }
                },
                {
                    "name": "promo",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "promo"
                            },
                            {
                                "kind": "account",
                                "type": "publicKey",
                                "account": "Mint",
                                "path": "mint"
                            }
                        ]
                    }
                },
                {
                    "name": "platform",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "adminSettings",
                    "isMut": false,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "admin"
                            }
                        ]
                    }
                },
                {
                    "name": "metadataProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "promoData",
                    "type": {
                        "defined": "Promo"
                    }
                },
                {
                    "name": "metadataData",
                    "type": {
                        "defined": "DataV2"
                    }
                },
                {
                    "name": "isMutable",
                    "type": "bool"
                }
            ]
        },
        {
            "name": "mintPromoToken",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "promoOwner",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "mint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "authority"
                            }
                        ]
                    }
                },
                {
                    "name": "promo",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "promo"
                            },
                            {
                                "kind": "account",
                                "type": "publicKey",
                                "account": "Mint",
                                "path": "mint"
                            }
                        ]
                    }
                },
                {
                    "name": "adminSettings",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "admin"
                            }
                        ]
                    }
                },
                {
                    "name": "tokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "associatedTokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "delegatePromoToken",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "authority"
                            }
                        ]
                    }
                },
                {
                    "name": "promo",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "promo"
                            },
                            {
                                "kind": "account",
                                "type": "publicKey",
                                "account": "TokenAccount",
                                "path": "token_account.mint"
                            }
                        ]
                    }
                },
                {
                    "name": "tokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "burnPromoToken",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "promoOwner",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "mint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "authority"
                            }
                        ]
                    }
                },
                {
                    "name": "promo",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "promo"
                            },
                            {
                                "kind": "account",
                                "type": "publicKey",
                                "account": "Mint",
                                "path": "mint"
                            }
                        ]
                    }
                },
                {
                    "name": "platform",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "adminSettings",
                    "isMut": true,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "admin"
                            }
                        ]
                    }
                },
                {
                    "name": "tokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "associatedTokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "createNonFungible",
            "accounts": [
                {
                    "name": "payer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "authority",
                    "isMut": false,
                    "isSigner": false,
                    "pda": {
                        "seeds": [
                            {
                                "kind": "const",
                                "type": "string",
                                "value": "authority"
                            }
                        ]
                    }
                },
                {
                    "name": "mint",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "tokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "metadataAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "editionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "metadataProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "associatedTokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "data",
                    "type": {
                        "defined": "DataV2"
                    }
                },
                {
                    "name": "isMutable",
                    "type": "bool"
                },
                {
                    "name": "maxSupply",
                    "type": {
                        "option": "u64"
                    }
                }
            ]
        }
    ],
    "accounts": [
        {
            "name": "AdminSettings",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "platform",
                        "type": "publicKey"
                    },
                    {
                        "name": "createPromoLamports",
                        "type": "u64"
                    },
                    {
                        "name": "burnPromoTokenLamports",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "Promo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner",
                        "type": "publicKey"
                    },
                    {
                        "name": "mints",
                        "type": "u32"
                    },
                    {
                        "name": "burns",
                        "type": "u32"
                    },
                    {
                        "name": "maxMint",
                        "type": {
                            "option": "u32"
                        }
                    },
                    {
                        "name": "maxBurn",
                        "type": {
                            "option": "u32"
                        }
                    }
                ]
            }
        }
    ],
    "types": [
        {
            "name": "DataV2",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "name": "uri",
                        "type": "string"
                    },
                    {
                        "name": "sellerFeeBasisPoints",
                        "type": "u16"
                    },
                    {
                        "name": "creators",
                        "type": {
                            "option": {
                                "vec": {
                                    "defined": "Creator"
                                }
                            }
                        }
                    },
                    {
                        "name": "collection",
                        "type": {
                            "option": {
                                "defined": "Collection"
                            }
                        }
                    },
                    {
                        "name": "uses",
                        "type": {
                            "option": {
                                "defined": "Uses"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "Creator",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "address",
                        "type": "publicKey"
                    },
                    {
                        "name": "verified",
                        "type": "bool"
                    },
                    {
                        "name": "share",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "Uses",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "useMethod",
                        "type": {
                            "defined": "UseMethod"
                        }
                    },
                    {
                        "name": "remaining",
                        "type": "u64"
                    },
                    {
                        "name": "total",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "Collection",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "verified",
                        "type": "bool"
                    },
                    {
                        "name": "key",
                        "type": "publicKey"
                    }
                ]
            }
        },
        {
            "name": "UseMethod",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Burn"
                    },
                    {
                        "name": "Multiple"
                    },
                    {
                        "name": "Single"
                    }
                ]
            }
        }
    ],
    "events": [
        {
            "name": "MintEvent",
            "fields": [
                {
                    "name": "mint",
                    "type": "string",
                    "index": true
                },
                {
                    "name": "tokenAccount",
                    "type": "string",
                    "index": false
                }
            ]
        }
    ],
    "errors": [
        {
            "code": 6000,
            "name": "MaxMintExceeded",
            "msg": "Max mints exceeded."
        },
        {
            "code": 6001,
            "name": "MaxBurnExceeded",
            "msg": "Max burns exceeded."
        },
        {
            "code": 6002,
            "name": "ExpiryExceeded",
            "msg": "Expiry exceeded."
        }
    ]
}
